export default [
  {
    path: "/upload-paper/index",
    name: "index",
    component: () => import("@/views/upload-paper/index"),
    meta: {
      title: ""
    }
  },
  {
    path: "/upload-paper/upload",
    name: "pdf",
    component: () => import("@/views/upload-paper/upload"),
    meta: {
      title: ""
    }
  }
];
